/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ProgramasControllerDescargarEncuestaCancelacion$Params {

/**
 * UUID del programa
 */
  uuidPrograma: string;
}

export function programasControllerDescargarEncuestaCancelacion(http: HttpClient, rootUrl: string, params: ProgramasControllerDescargarEncuestaCancelacion$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, programasControllerDescargarEncuestaCancelacion.PATH, 'get');
  if (params) {
    rb.path('uuidPrograma', params.uuidPrograma, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

programasControllerDescargarEncuestaCancelacion.PATH = '/api/programas/descargar-encuesta-cancelacion/{uuidPrograma}';
